// BUILD-046 task 8.12: the Caller summary (GET /work/me) for the HQ shell. AppLayout reads one flag from it, `canAdministerGroups`, to show the
// Work groups nav item (Req 6.18). The flag is a convenience, not a control: the server checks the authority on every group request.
//
// Failure is quiet and safe: when the call fails (the new routes are disabled, no identity, no connection) `me` stays null, so the nav item
// is not shown and the shell is exactly the legacy shell. It never reloads the page and never retries on its own (api/workShared.ts).
// The summary is read again when the Caller changes, and an answer for the previous Caller is discarded (Req 2.7).
import { useEffect, useState } from 'react';
import { onCallerChanged, workApi } from '../../api/workShared';
import type { WorkMe } from '../../api/workShared';

export interface WorkMeState {
  me: WorkMe | null;
  loading: boolean;
}

export function useWorkMe(): WorkMeState {
  const [state, setState] = useState<WorkMeState>({ me: null, loading: true });
  useEffect(() => {
    let current = true;
    let seq = 0;
    function load(): void {
      seq += 1;
      const mine = seq;
      setState({ me: null, loading: true });
      workApi
        .getMe()
        .then((me) => {
          if (current && mine === seq) setState({ me, loading: false });
        })
        .catch(() => {
          if (current && mine === seq) setState({ me: null, loading: false });
        });
    }
    load();
    const off = onCallerChanged(load);
    return () => {
      current = false;
      off();
    };
  }, []);
  return state;
}
